<template>
    <v-hover>
        <v-card flat hover slot-scope="{ hover }">
            <v-card-text>
                <div class="display-3">{{ (value.label)? value.label : d.label }}</div>
                <div v-if="hover">
                    <br>
                    <v-divider></v-divider>
                    <v-layout>
                        <v-flex>
                            <v-text-field label="Etiqueta" v-model="d.label" @input="input"></v-text-field>
                        </v-flex>
                    </v-layout>
                </div>
            </v-card-text>
        </v-card>
    </v-hover>
</template>

<script>
    export default {
        name: "texto",
        props: ['value'],
        data() {
            return {
                d: {
                    label: 'Titulo',
                }
            }
        },
        methods: {
            input() {
                this.$emit('input', this.d);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/formulario/tipos/subtitulo.vue